module.exports = __webpack_public_path__ + "static/icon-large-requirements.20a9515e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-large-requirements.svg
// module id = 371
// module chunks = 4240319048455 162898551421021